import { DomainError } from '../../domain/shared/DomainError';
import { PersistenceError } from './PersistenceError';

export class RoutineError extends DomainError {
  public constructor(code: string, message: string) {
    super(code, message);
    this.name = 'RoutineError';
  }
}

export function toRoutineError(error: unknown): RoutineError {
  if (error instanceof RoutineError) return error;
  if (error instanceof PersistenceError) {
    const messages: Readonly<Record<string, string>> = {
      database_unavailable: 'Le stockage local est indisponible sur ce navigateur.',
      persistence_read_failed: 'Les données locales ne peuvent pas être lues pour le moment.',
      persistence_write_failed: 'Les changements ne peuvent pas être enregistrés localement.',
      persistence_migration_failed: 'La base locale ne peut pas être mise à niveau.',
      persistence_validation_failed: 'Les données locales ne respectent pas le format attendu.',
    };
    return new RoutineError(error.code, messages[error.code] ?? 'La préparation locale a échoué.');
  }
  if (error instanceof DomainError) return new RoutineError(error.code, error.message);
  return new RoutineError(
    'routine_unavailable',
    'La journée ne peut pas être chargée pour le moment.',
  );
}
